// removed by extract-text-webpack-plugin
module.exports = {"hopperContainer":"_22SXRIH4vQka4yZd-njwSR","hopper":"_2pAAaCTrFVgodfdQtGJX-1","hopperLevel":"_272ebRzIYBSejoW9j2TSJu","wheat":"_2EVrTsdgqjRMIBQFXZ8iRa","rape":"_3D2Dr1aBUJX0D4Hn6phaXd","soy":"OQj8vfyoZhbKtOrd4eXZp","corn":"_3yoNhJKB7Nd0Maiaj8LKgE","sunflower":"j1Bsn9hlflWy5ZaJXoQyD","idle":"_1336mBUpe4b6c-WKt2jezn","clogged":"_1mb44WP0DFg_3lUnecnwoD","cloggedHopper":"fejAoj0aRHIUbARyktkav","hopperNumbers":"_2SsjrheN60mOw4KYY843La","inPath":"_2Jf4K4pTZF32N-xYRH7FU3"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/components/Game/SubComponents/Hopper/index.css
// module id = 195
// module chunks = 0